import { ChildModel, ModelBase } from 'store/model-base';
import { DataPlan } from './data-plan';
import { PlanSubGroupType } from 'core/constants';

export class PlanEligibility extends ModelBase {
    public static storeName: string = 'planEligibility';
    public basicPlanId: string;

    public plans: DataPlan[];

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'plans',
            model: DataPlan
        }];
    }

    public static create<T extends ModelBase>(initData: ApiResponse): T {
        const toReturn: PlanEligibility = super.create<PlanEligibility>(initData);
    
        toReturn.basicPlanId = (toReturn.plans.length && toReturn.plans.find((plan: DataPlan) => plan.planSubgroup === PlanSubGroupType.BASIC))?.id;
        toReturn.basicPlanId = toReturn.basicPlanId || (toReturn.plans.length && toReturn.plans[0].id);
    
        return <T> <ModelBase> toReturn;
    }
}
